//--------------------------------------------------------------------//
//******************** sipTrunksTable **********************************//
//--------------------------------------------------------------------//
// Renders the SIP trunks listing table. Clicking a row opens the parent
// tab's trunk detail popup (via the onOpen callback — see sipTrunksCtrl's
// openTrunkDetail). Delete action shows a confirmation dialog, mirroring
// deployments.directive.js's showDeleteDeploymentPopup.
import './sipTrunks.scss';
import './sipTrunks.service.js';
import './trunk-info/trunk-info.tab.js';
import './trunk-numbers/trunk-numbers.tab.js';
import './trunk-short-code/trunk-short-code.tab.js';
import './trunk-sms/trunk-sms.tab.js';
import './trunk-connected-apps/trunk-connected-apps.tab.js';
import './trunk-debug/trunk-debug.tab.js';

angular.module('sipTrunksTableModule')

    .directive('sipTrunksTable', ['GhDialog', 'SipTrunksService', function (GhDialog, SipTrunksService) {
        return {
            restrict: 'E',
            scope: {
                sipTrunks: '=',
                onOpen: '&'
            },

            controller: ['$scope', 'localizationService', function ($scope, localizationService) {
                const dictionary = localizationService.getDictionary('account_settings');
                $scope.translate = (word) => localizationService.translate(word, dictionary);

                if (!Array.isArray($scope.sipTrunks)) {
                    $scope.sipTrunks = [];
                }

                $scope.$watchCollection('sipTrunks', function (newValue) {
                    if (!Array.isArray(newValue)) {
                        $scope.sipTrunks = [];
                    }
                });

                $scope.didCount = function (trunk) {
                    return Array.isArray(trunk.did_numbers) ? trunk.did_numbers.length : 0;
                };

                $scope.openTrunk = function (trunk) {
                    $scope.onOpen({ trunk });
                };

                // Opens a confirmation dialog to delete a trunk. On confirm, calls
                // the API and removes the trunk from the list.
                $scope.showDeleteTrunkPopup = function (trunk) {
                    const tableScope = $scope;

                    GhDialog.show({
                        position: 'center',
                        toolbar: false,
                        template: {
                            toolbar: '',
                            resizable: false,
                            content: `
                                <div class="delete_sip_trunk-popup">
                                    <div class="dialog-share-group">
                                        <span gh-icon="rubbish FF0D0D 65px"></span>
                                        <p class="dialog-share-group__title">{{translate('Deleting Trunk!')}}</p>
                                    </div>

                                    <div class="dialog-share-group__content">
                                        <p class="info">
                                            {{translate('Do you really want to delete this SIP trunk? FreeSWITCH will stop offering it immediately.')}}
                                        </p>

                                        <div class="dialog-share-group__content__buttons">
                                            <button
                                                class="dialog-share-group__content__buttons__add btn btn-blue-reverse"
                                                ng-click="deleteTrunk()"
                                                ng-disabled="deleting"
                                            >
                                                {{deleting ? translate('Deleting...') : translate('Delete')}}
                                            </button>

                                            <button
                                                class="dialog-share-group__content__buttons__cancel btn btn-blue"
                                                ng-click="cancel()"
                                            >
                                                {{translate('Cancel')}}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            `
                        },
                        locals: {
                            trunk
                        },
                        controller: [
                            '$scope',
                            'trunk',
                            'localizationService',
                            'SipTrunksService',
                            function ($scope, trunk, localizationService, SipTrunksService) {
                                const dictionary = localizationService.getDictionary('account_settings');
                                $scope.translate = (word) => localizationService.translate(word, dictionary);
                                $scope.deleting = false;

                                $scope.deleteTrunk = async function () {
                                    $scope.deleting = true;
                                    try {
                                        await SipTrunksService.delete(trunk.trunk_id);

                                        if (!Array.isArray(tableScope.sipTrunks)) {
                                            tableScope.sipTrunks = [];
                                        }

                                        const index = tableScope.sipTrunks.findIndex(function (t) {
                                            return t.trunk_id === trunk.trunk_id;
                                        });

                                        if (index !== -1) {
                                            tableScope.sipTrunks.splice(index, 1);
                                        }

                                        tableScope.$applyAsync();
                                        $scope.cancel();
                                    } catch (error) {
                                        console.log('Trunk delete error:', error);
                                        $scope.deleting = false;
                                        $scope.$applyAsync();
                                    }
                                };
                            }
                        ]
                    });
                };
            }],

            template: `
                <div class="listing_table">
                    <div class="listing_table_head_wrapper">
                        <div class="listing_table_column bottom_line w-40">
                            <div class="tab">{{translate('Name')}}</div>
                        </div>

                        <div class="listing_table_column w-20">
                            <div class="tab">{{translate('Register')}}</div>
                        </div>

                        <div class="listing_table_column w-20">
                            <div class="tab">{{translate('Status')}}</div>
                        </div>

                        <div class="listing_table_column w-10">
                            <div class="tab">{{translate('DIDs')}}</div>
                        </div>

                        <div class="listing_table_column w-10"></div>
                    </div>

                    <div class="listing_table_body_wrapper">
                        <div
                            class="listing_table_row"
                            ng-click="openTrunk(trunk)"
                            ng-repeat="trunk in sipTrunks track by trunk.trunk_id"
                        >
                            <div class="listing_table_column w-40">
                                <span class="number">{{$index + 1}}</span>
                                <div class="name">{{trunk.name}}</div>
                            </div>

                            <div class="listing_table_column w-20">
                                {{trunk.register ? translate('Yes') : translate('No')}}
                            </div>

                            <div class="listing_table_column w-20">
                                <span
                                    class="status-badge"
                                    ng-class="trunk.enabled ? 'running' : 'stopped'"
                                >
                                    {{trunk.enabled ? translate('Enabled') : translate('Disabled')}}
                                </span>
                            </div>

                            <div class="listing_table_column w-10">
                                {{didCount(trunk)}}
                            </div>

                            <div class="listing_table_column w-10">
                                <span
                                    ng-click="showDeleteTrunkPopup(trunk); $event.stopPropagation()"
                                    class="delete_icon"
                                    gh-icon="rubbish 0d99ff 20px"
                                ></span>
                            </div>
                        </div>

                        <div ng-if="!sipTrunks.length" class="listing_table_nodata">
                            <p>{{translate('No SIP Trunks')}}</p>
                        </div>
                    </div>
                </div>
            `
        };
    }]);
